// extracted by mini-css-extract-plugin
export default {"main":"BaseSimpleItemEditor_main__W6s5L","scrollContent":"BaseSimpleItemEditor_scrollContent__WA822"};